import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { translations } from '../i18n/translations';

const LanguageContext = createContext(null);

const EN_TIMEZONES = [
  'America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles',
  'America/Phoenix', 'America/Anchorage', 'Pacific/Honolulu', 'Europe/London'
];

function detectLanguage() {
  const stored = localStorage.getItem('site_lang');
  if (stored === 'es' || stored === 'en') return stored;

  const navLang = (navigator.language || '').toLowerCase();
  if (navLang.startsWith('es')) return 'es';
  if (navLang.startsWith('en')) return 'en';

  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  if (EN_TIMEZONES.includes(tz)) return 'en';

  return 'es';
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState('es');

  useEffect(() => {
    setLang(detectLanguage());
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const changeLanguage = (newLang) => {
    localStorage.setItem('site_lang', newLang);
    setLang(newLang);
  };

  const value = useMemo(() => ({
    lang,
    changeLanguage,
    t: translations[lang] || translations.es
  }), [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used inside LanguageProvider');
  return context;
}
